export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ02.deb245ea.mp3";